import { Carousel } from "@mantine/carousel"
import {
  AspectRatio,
  Blockquote,
  Box,
  Button,
  Card,
  Image,
  Paper,
  rem,
  SimpleGrid,
  Space,
  Stack,
  Text,
  Title
} from "@mantine/core"
import { IconDownload, IconHeartHandshake } from "@tabler/icons-react"
import { motion } from "framer-motion"
import { useNavigate } from "react-router-dom"
import Silk from "../../Components/Silk"
import { features, gallery, missionVision, qualities, subsidaries } from "../../data"
import { footer, mainHeader, primaryCard, subsidiaryCard } from "../Common/Renders"
import { featureCard, qualityCard } from "./Renders"

export function Home(): React.ReactElement {
  const navigate = useNavigate()

  return (
    <Box p={"md"}>
      {mainHeader()}

      <Space h={rem(48)} />

      <Carousel
        withIndicators
        withControls={false}
        slideSize={{ base: "60%" }}
        slideGap={{ base: "sm", sm: "md" }}
        emblaOptions={{ loop: true, align: "start" }}
      >
        {gallery.map((image, index) => (
          <Carousel.Slide key={index}>
            <AspectRatio ratio={16 / 9}>
              <Image src={image} />
            </AspectRatio>
          </Carousel.Slide>
        ))}
      </Carousel>

      <Paper my={rem(48)} bg={"#1E1E1E"} p={rem(24)} withBorder radius={rem(16)} shadow="sm">
        <Text size={rem(24)} c={"white"} fw={300} ta={"center"}>
          {"Empowering communities with transparent and innovative microfinance solutions"}
        </Text>
      </Paper>

      <SimpleGrid className="products" cols={{ base: 1, sm: 2, md: 4 }} spacing={rem(32)}>
        {missionVision.map((card, index) => primaryCard(index, card.image, card.title, card.content))}
      </SimpleGrid>

      <Box my={rem(32)}>
        <motion.div initial={{ opacity: 0, y: 75 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.75 }}>
          <Title order={2}>Why Dharohar Group?</Title>
          <Text c="dimmed" mb="md" size="lg">
            We are not just a company — we are on a mission to empower India.
          </Text>

          <SimpleGrid cols={{ base: 1, sm: 2 }}>
            {features.map((feature, index) => featureCard(index, feature))}
          </SimpleGrid>
        </motion.div>
      </Box>

      <Stack my={rem(32)}>
        <Title order={2}>Features</Title>

        <SimpleGrid cols={{ base: 1, sm: 2, md: 3 }} spacing={rem(16)}>
          {qualities.map((feature, index) => qualityCard(index, feature))}
        </SimpleGrid>
      </Stack>

      <Stack my={rem(32)}>
        <Title order={2}> Our Subsidiaries</Title>

        <SimpleGrid cols={{ base: 1, sm: 2, md: 3 }} spacing={rem(32)}>
          {subsidaries.map((subsidiary, index) => subsidiaryCard(index, subsidiary))}
        </SimpleGrid>
      </Stack>

      <Blockquote my={rem(32)} color="red" cite="– Mr. Vijay Patel, CEO" icon={<IconHeartHandshake size={rem(24)} />}>
        Dharohar Group operates through two dedicated Section 8 licensed units — Uttam Rural Micro Benefit Foundation
        and JBR Micro Services Foundation. Together, we strive to build a transparent, user-friendly financial ecosystem
        that drives exponential growth for all our stakeholders
      </Blockquote>

      <Box my={rem(32)} pos="relative" h={320}>
        <Box pos="absolute" top={0} left={0} w="100%" h="100%" style={{ zIndex: 1 }}>
          <div
            style={{
              position: "relative",
              border: "2px",
              borderRadius: "16px",
              height: rem(320),
              overflow: "hidden"
            }}
          >
            <Silk speed={5} scale={1} color="#7B7481" noiseIntensity={1.5} rotation={0} />
          </div>
        </Box>

        <Stack
          gap={"lg"}
          align={"end"}
          justify={"center"}
          pos={"relative"}
          style={{ zIndex: 2, textAlign: "right" }}
          p={"md"}
          w={"100%"}
          h={"100%"}
        >
          <Text size={rem(24)} c={"white"} fw={300} style={{ letterSpacing: rem(1.5) }}>
            WHO ARE WE?
          </Text>
          <Text size={rem(64)} c={"white"} fw={700}>
            Dharohar Group
          </Text>
          <Button variant={"default"} onClick={() => navigate("/about-us")}>
            Read More
          </Button>
        </Stack>
      </Box>

      <Stack>
        <Title order={2}>Downloads</Title>
        <SimpleGrid cols={{ base: 1, sm: 2, md: 3 }} spacing={rem(16)}>
          <Card shadow="sm" radius={rem(16)} withBorder p={rem(24)}>
            <Text size={rem(18)} fw={300} ta={"center"}>
              We are also available on Android, download our app now!
            </Text>
            <Button
              mt={rem(16)}
              color="green"
              size="md"
              leftSection={<IconDownload />}
              onClick={() => window.open("https://dharohargroup.com/downloads/ebiz.finazer.JbrNidhi-1.1.apk", "_blank")}
            >
              Download
            </Button>
          </Card>
        </SimpleGrid>
      </Stack>

      <Space h={rem(48)} />

      {footer()}
    </Box>
  )
}
